import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import { withMainControls } from '@eb/eds-structure';
import { TYPE_ERROR } from '@eb/eds-notification';

import SetPasswordForm from '../../components/forms/SetPasswordForm';
import LookUpForm from '../../components/forms/LookUpForm';
import PageHeader from '../../components/PageHeader';
import {
    RESET_PASSWORD_PATH,
    TRIGGER_RESET_PASSWORD,
    SET_PASSWORD_PATH,
} from '../../constants';
import { PAGE_HEADER_INFO_MAP } from '../../constants/messages';
import { getSetPasswordFormType } from '../../utils';

import { AlertChunky } from '@eb/eds-iconography';

const DYNAMIC_FORM_MAP = {
    [TRIGGER_RESET_PASSWORD]: LookUpForm,
    [RESET_PASSWORD_PATH]: SetPasswordForm,
    [SET_PASSWORD_PATH]: SetPasswordForm,
};

class SetPasswordPage extends React.PureComponent {
    static propTypes = {
        handleSetPassword: PropTypes.func.isRequired,
        handleResetPassword: PropTypes.func.isRequired,
        locale: PropTypes.string,
        hideMainNotification: PropTypes.func,
        addMainNotification: PropTypes.func,
    };

    _handleShowNotification(error) {
        const { addMainNotification } = this.props;

        /*Limit the call to addMainNotification to only if
        a notification hasn't been shown since last submit.*/
        if (!this._hasNotification) {
            addMainNotification({
                type: TYPE_ERROR,
                children: error,
                iconType: <AlertChunky />,
            });

            this._hasNotification = true;
        }
    }

    _handleClearNotification() {
        const { hideMainNotification } = this.props;

        this._hasNotification = false;
        hideMainNotification();
    }

    _getFormType() {
        const {
            route: { path: formType },
            router: {
                location: { query },
            },
        } = this.props;

        return getSetPasswordFormType(formType, query);
    }

    _getSubmitAction(formType) {
        const { handleSetPassword, handleResetPassword } = this.props;

        const actionMap = {
            [TRIGGER_RESET_PASSWORD]: handleResetPassword,
            [RESET_PASSWORD_PATH]: handleSetPassword,
            [SET_PASSWORD_PATH]: handleSetPassword,
        };

        return actionMap[formType];
    }

    render() {
        const { locale } = this.props;

        const formType = this._getFormType();
        const submitAction = this._getSubmitAction(formType);
        const DynamicForm = DYNAMIC_FORM_MAP[formType];
        const shouldHideLegalCopy = formType === RESET_PASSWORD_PATH;
        const {
            headerText,
            iconType,
            subtitleText,
            buttonCTA,
        } = PAGE_HEADER_INFO_MAP[formType];

        const gridClasses = classNames(
            'eds-g-cell',
            'container-max-width',
            'eds-g-cell--has-overflow',
        );

        return (
            <div className="eds-l-mar-vert-14">
                <div className="eds-g-group eds-align--center">
                    <div className={gridClasses}>
                        <PageHeader
                            headerText={headerText}
                            subtitleText={subtitleText}
                            iconType={iconType}
                        />
                        <DynamicForm
                            onSubmit={submitAction}
                            headerText={headerText}
                            iconType={iconType}
                            subtitleText={subtitleText}
                            buttonCTA={buttonCTA}
                            shouldHideLegalCopy={shouldHideLegalCopy}
                            locale={locale}
                            showNotification={this._handleShowNotification.bind(
                                this,
                            )}
                            clearNotification={this._handleClearNotification.bind(
                                this,
                            )}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default withMainControls(SetPasswordPage);
